export const APP_TYPE = 'employee-portal' as const;

export type AppTypeSlug = typeof APP_TYPE;
